"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLaunchDarkly = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var context_1 = require("launchdarkly-react-client-sdk/lib/context");
var constants_1 = require("./constants");
var emptyState = {
    flags: {},
};
var withLaunchDarkly = function (Story, context) {
    var params = context.parameters[constants_1.PARAM_KEY];
    return ((0, jsx_runtime_1.jsx)(context_1.Provider, (0, tslib_1.__assign)({ value: params || emptyState }, { children: (0, jsx_runtime_1.jsx)(Story, {}, void 0) }), void 0));
};
exports.withLaunchDarkly = withLaunchDarkly;
//# sourceMappingURL=decorators.js.map